// extracted by mini-css-extract-plugin
export var sectionText = "SectionText-module--sectionText--MmG6N";
export var title = "SectionText-module--title--JXNBZ";
export var text = "SectionText-module--text--c8K98";
export var link = "SectionText-module--link--UhdOJ";
export var underline = "SectionText-module--underline--jnVeE";
export var underlineOnHover = "SectionText-module--underlineOnHover--+dMnr";
export var fakeGrid = "SectionText-module--fakeGrid--A5lVq";